import { Link, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import { ArrowRight, X, WhatsappLogo } from "@phosphor-icons/react";
import { getDeadlineInfo } from "@/lib/deadline";

export default function StickyCTA() {
  const { pathname } = useLocation();
  const [closed, setClosed] = useState(false);
  const [show, setShow] = useState(false);

  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 800);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  if (closed || !show) return null;
  if (["/kayit", "/giris", "/basla", "/kayit-ol", "/admin", "/panelim"].some(p => pathname.startsWith(p))) return null;

  const d = getDeadlineInfo();
  const isUrgent = d.urgency === "critical" || d.urgency === "warning";

  return (
    <div className={`fixed bottom-5 left-5 right-5 md:left-auto md:right-6 md:max-w-sm z-40 border rounded-xl shadow-[0_20px_50px_-12px_rgba(15,23,42,0.18)] p-4 ${isUrgent ? "bg-brand-error text-white border-brand-error" : "bg-white border-stone-200"}`} data-testid="sticky-cta">
      <button onClick={() => setClosed(true)} className={`absolute top-2.5 right-2.5 w-6 h-6 rounded-md flex items-center justify-center ${isUrgent ? "text-white/70 hover:text-white hover:bg-white/10" : "text-stone-400 hover:text-stone-700 hover:bg-stone-100"}`} data-testid="sticky-cta-close"><X weight="bold" size={14}/></button>
      <div className="flex items-start gap-3 pr-6">
        <img src="/estem-logo.png" alt="Estem" className="h-10 w-auto object-contain shrink-0 rounded bg-white p-0.5"/>
        <div>
          <div className={`font-heading font-bold text-[15px] leading-tight ${isUrgent ? "text-white" : "text-brand-ink"}`}>{isUrgent ? d.headline : d.badge}</div>
          <div className={`text-xs mt-0.5 ${isUrgent ? "text-white/85" : "text-stone-500"}`}>{isUrgent ? d.subline : "5 dakikada online başvurunuzu tamamlayın."}</div>
        </div>
      </div>
      <div className="mt-3 flex gap-2">
        <Link to="/basla" className={`flex-1 rounded-lg font-semibold text-xs px-4 py-2 flex items-center justify-center gap-1 transition-colors ${isUrgent ? "bg-white text-brand-error hover:bg-stone-100" : "nb-btn !py-2 !text-xs"}`} data-testid="sticky-cta-register">
          {isUrgent ? "ŞİMDİ KAYIT OL" : "Online Başvuru"} <ArrowRight weight="bold" size={13}/>
        </Link>
        <a href="https://wa.me/+905436566346" target="_blank" rel="noreferrer" className={`rounded-lg px-3 py-2 flex items-center justify-center transition-colors ${isUrgent ? "bg-white text-brand-error hover:bg-stone-100" : "nb-btn-outline !py-2 !text-xs !px-3"}`}><WhatsappLogo weight="bold" size={14}/></a>
      </div>
    </div>
  );
}
